import base from './base';
import { permissionComputeds } from './base';

export default {
	mixins: [base],
	computed: permissionComputeds('VIEW_ROLE', 'ADD_ROLE', 'CHANGE_ROLE', 'DELETE_ROLE'),
};
